module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/footer/footer.component.css
// module id = ./src/app/Screens/footer/footer.component.css
// module chunks = main